import d3 from 'd3';
import _ from 'lodash';
import MultipleFacetView from './MultipleFacetView';

class StackFacetView extends MultipleFacetView {

  constructor(config, $el, margins) {
    super(config, $el, margins);
    this._title = 'Stack Chart';
  }

  _updateGroups() {
    super._updateGroups();
    this._dataGroup = this._updateDataGroup(this._g);
    this._labelsGroup = this._updateLabelsGroup(this._g);
  }

  _updateDataGroup(parent) {
    const group = parent.selectAll('g.data').data(['g']);
    group.enter().append('g')
      .attr('class', 'data')
      .style('cursor', 'crosshair');
    return group;
  }

  _updateLabelsGroup(parent) {
    const group = parent.selectAll('g.labels').data(['g']);
    group.enter().append('g')
      .attr('class', 'labels')
      .style('pointer-events', 'none');
    return group;
  }

  // override
  _updateScales() {
    if (!this._xValue || !this._yValue || !this._data) return;

    this._yMax = d3.sum(this._data, this._yValue);
    this._yScale = this._yScaleFunction.domain([0, this._yMax]).rangeRound([0, this._height]);

    this._total = 0;
    // const filteredData = this._data.filter(d => this._yValue(d) > 1);
    this._stack = _.map(this._data, d => {
      const o = {
        data: d,
        y: this._total,
        value: this._yValue(d),
      };
      this._total += o.value;
      return o;
    });

    this._drawChart();
  }

  _updateData() {
    if (!this._facet || !this._facet.groups()) return;
    this._data = this._facet.groups(this._limit)
      .sort((itema, itemb) => {
        return this._xValue(itema) > this._xValue(itemb) ? -1 : 1;
      });
    this._updateScales();
  }

  _drawChart() {
    this._drawData();
    this._drawLabels();
  }

  // override
  _drawData() {
    const bars = this._dataGroup.selectAll('rect').data(this._stack, d => this._xValue(d.data));

    bars.enter()
      .append('rect')
      .on('mouseover', d => this._onMouseOver(d))
      .on('mouseout', d => this._onMouseOut(d))
      .on('mousedown', d => this._onMouseDown(d))
      .on('mouseup', d => this._onMouseUp(d));

    bars.attr('x', 0)
      .attr('y', d => this._yScale(d.y))
      .attr('width', this._width)
      .style('fill', d => this._isSelected(d) ? this._selectedUpColor : this._upColor)
      .attr('height', d => this._yScale(d.value) - this._spacing);

    bars.exit().remove();
  }

  // override
  _drawLabels() {
    const labels = this._labelsGroup.selectAll('text').data(this._stack);

    labels.enter()
      .append('text')
      .attr('class', 'stacklabel')
      .style('alignment-baseline', 'middle')
      .style('text-anchor', 'middle');

    labels
      .text(d => `${this._xLabel(d.data)}: ${this._yFormat(d.value / this._total)}`)
      .attr('x', this._width / 2)
      .attr('y', d => this._yScale(d.y + (d.value / 2)))
      .style('fill', d => this._isSelected(d) ? this._selectedUpColorBg : this._upColorBg);

    labels.exit().remove();
  }

  _drawSelection(d, state) {
    let color;
    if (state === 'over') color = this._isSelected(d) ? '_selectedOverColor' : '_overColor';
    if (state === 'down') color = this._isSelected(d) ? '_selectedDownColor' : '_downColor';
    if (state === 'up') color = this._isSelected(d) ? '_selectedUpColor' : '_upColor';
    this._dataGroup
      .selectAll('rect')
      .data([d], dd => this._xValue(dd.data))
      .style('fill', this[color]);
    this._labelsGroup
      .selectAll('text')
      .data([d], dd => this._xValue(dd.data))
      .style('fill', this[`${color}Bg`]);
  }

  _select(d, value) {
    if (value) this._selectedMap[this._xValue(d.data)] = true;
    else delete this._selectedMap[this._xValue(d.data)];
  }

  _isSelected(d) {
    return this._selectedMap[this._xValue(d.data)] !== undefined;
  }

  _onExtentSelected() {
    let selectedLength = _.size(this._selectedMap);
    if (selectedLength === this._data.length) {
      this._selectedMap = {};
      selectedLength = 0;
    }

    const values = _.keys(this._selectedMap);
    if (!values || !values.length) this._facet.clear();
    else this._facet.filterMultiple(values);
  }

}

module.exports = StackFacetView;



/** WEBPACK FOOTER **
 ** D:/2016/2016 - ISI/grantorino/frontend/../../../../Marco/Dropbox (ISI Foundation)/2016 - ISI/grantorino/frontend/src/js/views/sidebar/archive/facets/StackFacetView.es6
 **/